export const BRAND = {
  name: "RK Enterprises",
  tagline: "Reliable Manpower Solutions for Modern Industries",
  proprietor: "Mr. Ramesh Krishnan V",
  logo: "https://customer-assets.emergentagent.com/job_rk-skilled-labor/artifacts/sb7yo51x_Interlocking%20%27RK%27%20Monogram%20with%20Diverse%20Silhouettes.png",
  phones: ["+91 98403 12611", "+91 94444 66214"],
  whatsapp: "919840312611", // primary phone for WhatsApp
  emails: ["rkenterprises9726@gmail.com", "gauthamenterprises2017@gmail.com"],
  address: {
    line1: "1A, Mullai Street, Saraswathi Nagar",
    line2: "Avadi, Chennai – India",
    full: "1A, Mullai Street, Saraswathi Nagar, Avadi, Chennai, India",
  },
  hours: "Mon – Sat · 9:00 AM – 7:00 PM",
};

export const IMAGES = {
  // Hero portrait — Indian male operator at hydraulic press stamping car door panels
  factoryWorkers: "/images/hero.jpg",
  // Wide factory floor banner — Indian production line
  factoryAssembly: "/images/factory-floor.jpg",
  // Female engineer + male workers inspecting car door panels (About / Contact bg)
  corporateMeeting: "/images/leadership.jpg",
  // Indian female worker at metal tube bending machine (alt portrait)
  housekeepingStaff: "/images/alt-portrait.jpg",
  // Steel tube handling at fabrication bay (Careers bg)
  industrialWorker: "/images/careers.jpg",
  // Two female technicians inspecting car door panel (Benefits bg)
  femaleEngineer: "/images/benefits.jpg",
};

// Workforce gallery — Indian men and women in auto component / hydraulic / press work
export const WORKFORCE_GALLERY = [
  {
    src: "/images/gallery-1.jpg",
    alt: "Indian female welder TIG-welding an automotive bracket with sparks visible",
    caption: "Welding & Fabrication",
  },
  {
    src: "/images/gallery-2.jpg",
    alt: "South Indian male operator at hydraulic press stamping car door panel",
    caption: "Press Operations",
  },
  {
    src: "/images/gallery-3.jpg",
    alt: "Bundle of finished steel automotive hydraulic tubes on factory trolley",
    caption: "Hydraulic Tubes",
  },
  {
    src: "/images/gallery-4.jpg",
    alt: "Indian male technician inspecting glossy painted automotive car door panel",
    caption: "Paint & Finishing",
  },
  {
    src: "/images/gallery-5.jpg",
    alt: "Indian female engineer measuring an automotive component with vernier caliper",
    caption: "Quality Inspection",
  },
  {
    src: "/images/gallery-6.jpg",
    alt: "Factory supervisor training trainee workers at hydraulic press station",
    caption: "Training & Supervision",
  },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/careers", label: "Careers" },
  { to: "/benefits", label: "Employee Benefits" },
  { to: "/company-benefits", label: "For Companies" },
  { to: "/contact", label: "Contact" },
];

export const PARTNERS = [
  "Hyundai Motor India",
  "TVS Group",
  "Saint-Gobain",
  "Ashok Leyland",
  "Sundaram Clayton",
  "Caterpillar",
  "Wheels India",
  "Lucas-TVS",
  "MRF Tyres",
  "Royal Enfield",
];
